import MLCompactDark from './ml-compact-dark.svg';
import MLCompactLight from './ml-compact-light.svg';
import MLExtendedDark from './ml-extended-dark.svg';
import MLExtendedLight from './ml-extended-light.svg';
import MLLoginDark from './ml-login-dark.svg';
import MLLoginLight from './ml-login-light.svg';
import PFCompactDark from './pf-compact-dark.svg';
import PFCompactLight from './pf-compact-light.svg';
import PFExtendedDark from './pf-extended-dark.svg';
import PFExtendedLight from './pf-extended-light.svg';
import PGNCompactDark from './pgn-compact-dark.svg';
import PGNCompactLight from './pgn-compact-light.svg';
import PGNExtendedDark from './pgn-extended-dark.svg';
import PGNExtendedLight from './pgn-extended-light.svg';
import PLCompactDark from './pl-compact-dark.svg';
import PLCompactLight from './pl-compact-light.svg';
import PLExtendedDark from './pl-extended-dark.svg';
import PLExtendedLight from './pl-extended-light.svg';
export default {
    magicline: {
        light: {
            compact: MLCompactLight,
            extended: MLExtendedLight,
            LEGACY_login: MLLoginLight
        },
        dark: {
            compact: MLCompactDark,
            extended: MLExtendedDark,
            LEGACY_login: MLLoginDark
        }
    },
    'magicline-v2': {
        light: {
            compact: MLCompactLight,
            extended: MLExtendedLight,
            LEGACY_login: MLLoginLight
        },
        dark: {
            compact: MLCompactDark,
            extended: MLExtendedDark,
            LEGACY_login: MLLoginDark
        }
    },
    perfectgym: {
        light: {
            compact: PGNCompactLight,
            extended: PGNExtendedLight,
            LEGACY_login: PGNExtendedLight
        },
        dark: {
            compact: PGNCompactDark,
            extended: PGNExtendedDark,
            LEGACY_login: PGNExtendedLight
        }
    },
    perfectleisure: {
        light: {
            compact: PLCompactLight,
            extended: PLExtendedLight,
            LEGACY_login: PLExtendedLight
        },
        dark: {
            compact: PLCompactDark,
            extended: PLExtendedDark,
            LEGACY_login: PLExtendedLight
        }
    },
    'planet-fitness': {
        light: {
            compact: PFCompactLight,
            extended: PFExtendedLight,
            LEGACY_login: PFExtendedLight
        },
        dark: {
            compact: PFCompactDark,
            extended: PFExtendedDark,
            LEGACY_login: PFExtendedLight
        }
    }
};
